import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { rp, num, fmtDate, monthOptions } from "@/lib/format";
import { PageTitle, Panel, Stat, Pill } from "@/components/common";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function Bon() {
  const [month, setMonth] = useState(monthOptions(1)[0].value);
  const [worker, setWorker] = useState("ALL");
  const [workers, setWorkers] = useState([]);
  const [items, setItems] = useState([]);
  const months = monthOptions(12);

  useEffect(() => { api.get("/workers").then((r) => setWorkers(r.data)); }, []);

  const load = useCallback(() => {
    const p = new URLSearchParams({ transaction_type: "BON", status: "CONFIRMED", month, page_size: 500 });
    if (worker !== "ALL") p.append("worker_id", worker);
    api.get(`/transactions?${p.toString()}`).then((r) => setItems(r.data.items));
  }, [month, worker]);
  useEffect(() => { load(); }, [load]);

  const total = items.reduce((s, x) => s + (x.amount || 0), 0);
  const byItem = {};
  items.forEach((x) => {
    const k = x.bon_item_name || "LAINNYA";
    byItem[k] = (byItem[k] || 0) + (x.amount || 0);
  });

  return (
    <div>
      <PageTitle title="Bon Barang Pembantu" desc="Buku bon per pekerja. Harga snapshot per transaksi — tidak berubah."
        right={
          <div className="flex gap-2">
            <Select value={worker} onValueChange={setWorker}>
              <SelectTrigger className="w-48" data-testid="bon-worker"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="ALL">Semua Worker</SelectItem>{workers.map((w) => <SelectItem key={w.worker_id} value={w.worker_id}>{w.worker_id} — {w.worker_name}</SelectItem>)}</SelectContent>
            </Select>
            <Select value={month} onValueChange={setMonth}>
              <SelectTrigger className="w-44" data-testid="bon-month"><SelectValue /></SelectTrigger>
              <SelectContent>{months.map((m) => <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        } />

      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-5">
        <Panel className="sm:col-span-1"><Stat label="Total Bon" value={rp(total)} tone="indigo" sub={`${num(items.length)} transaksi`} /></Panel>
        {Object.entries(byItem).slice(0, 3).map(([k, v]) => (
          <Panel key={k}><Stat label={k} value={rp(v)} tone="indigo" /></Panel>
        ))}
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
        <table className="w-full text-left text-sm" data-testid="table-bon">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200 text-xs font-semibold uppercase tracking-wider text-slate-600">
              {["Tanggal", "Worker", "Barang", "Jumlah", "Harga Satuan", "Total", "Status"].map((h) => <th key={h} className="px-3 py-2.5">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.transaction_id} className="border-b border-slate-100 hover:bg-slate-50/80">
                <td className="px-3 py-2.5 text-slate-600 whitespace-nowrap">{fmtDate(t.transaction_date)}</td>
                <td className="px-3 py-2.5"><span className="font-semibold text-slate-800">{t.worker_id}</span> <span className="text-slate-500">{t.worker_name}</span></td>
                <td className="px-3 py-2.5 text-slate-700">{t.bon_item_name || "-"}</td>
                <td className="px-3 py-2.5 mono text-right">{num(t.quantity)} {t.unit}</td>
                <td className="px-3 py-2.5 mono text-right">{t.unit_price != null ? rp(t.unit_price) : <span className="text-amber-600 font-semibold">PRICE PENDING</span>}</td>
                <td className="px-3 py-2.5 mono text-right font-semibold">{t.amount ? rp(t.amount) : "-"}</td>
                <td className="px-3 py-2.5"><Pill value={t.status} /></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="px-3 py-10 text-center text-slate-400">Tidak ada bon.</td></tr>}
          </tbody>
          {items.length > 0 && (
            <tfoot>
              <tr className="bg-slate-50 border-t-2 border-slate-200 font-bold">
                <td colSpan={5} className="px-3 py-3 text-right uppercase text-xs tracking-wider text-slate-600">Total Bon</td>
                <td className="px-3 py-3 mono text-right text-indigo-700">{rp(total)}</td>
                <td></td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
